import React, {Component, PropTypes} from 'react';
import DatePicker from 'react-datepicker';

import 'react-month-picker-input/dist/react-month-picker-input.css';
import styled from 'styled-components';
import {
    Icon,
    Col,
    Button,
    FormGroup,
    InputGroup,
    FormControl, Table, ControlLabel
} from '@sketchpixy/rubix';
import {
  updateSerialNo,
  updatePatientSubscription
} from '../../api/api';
import NumberFormat from 'react-number-format';
import moment from 'moment';

import DeviceType from '../../constants/DeviceType';
import SideType from '../../constants/SideType';
import CurrencyType from '../../constants/CurrencyType';
import PaymentHistory from './PaymentHistory/PaymentHistory';
import PaymentInfo from './PaymentInfo/PaymentInfo';
import ArInfo from './PaymentInfo/ArInfo';
import BalanceInfo from './PaymentInfo/BalanceInfo';
import Charge from './PaymentInfo/Charge';
import ContractStatus from '../../constants/ContractStatus';
import SubscriptionStatus from '../../constants/SubscriptionStatus';
import CancelContractModal from './Modal/CancelContractModal';
import ActivateContractModal from './Modal/ActivateContractModal';
import EditProductModal from './Modal/EditProductModal';

const Container = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: ${props => props.expand ? '2px' : '1px'} solid #d8d8d8;

`;

const Title = styled.div`
  height: 65px;
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
  font-size: 18px;
`;


const ContractDetailTitle = styled.div`
  width: 202px;
  font-size: 16px;
`;

const ContractInfo = styled.div`
  display: flex;
  min-height: 60px;
  text-align: justify;
  padding: 0;
  border-bottom: ${props => props.expand ? '1px solid #d8d8d8' : ''};

  & div:first-child {
    color: black;
  }
  
  & div {
    margin-top: auto;
    margin-bottom: auto;
    padding: 0;
  }
`;

const ContractDetail = styled.div`
  padding-left: 44px;
  padding-right: 0;
`;

const ContractStatusText = styled.span`
  color: ${props => props.isActive ? '#42ae03' : '#aaaaaa'};
`;

const ContractCancelButton = styled(Button)`
  font-size: 12px;
  color: #717171;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  border: solid 1px #d8d8d8;
  padding: 6px 8px;
  margin-left: 22px;
  text-transform: capitalize;
`;

const ContractActivateButton = styled(ContractCancelButton)`
`;

const EditProductButton = styled(Button)`
  font-size: 12px;
  color: #717171;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  border: solid 1px #d8d8d8;
  padding: 6px 8px;
  margin-left: 22px;
  text-transform: capitalize;
`;

const ContractDetailItem = styled.div`
  display: flex;
  min-height: 60px;
  text-align: justify;

  &:last-child {
    border-bottom: 0;
  }
  
  & div:first-child {
    color: black;
  }
  
  & div {
    margin-top: auto;
    margin-bottom: auto;
    padding: 0;
  }
`;


const ExpandButton = styled.div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  
  & span {
    border: 1px solid #d8d8d8;
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    width: 26px;
    height: 26px;
    display: flex;
  }
  
  & span:before {
    margin: auto;
  }
`;

class Contract extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expand: props.expand ? props.expand : false,
      arrowButton: this.getArrowIcon(false),
      createdDate: null,
      medicalDevices: null,
      displayDevice: null,
      contractStatus: null,
      currencyType: null,
      currency: null,
      decimalScale: 0,
      patientSubscription: {},
      payments: [],
      showCancelContractModal: false,
      showActivateContractModal: false,
      showEditProductModal: false
    };
  }

  componentWillReceiveProps(nextProps) {
        this.initContractInfo(nextProps);
  }

  componentDidMount() {
      this.initContractInfo(this.props);
  }

  initContractInfo(props)
  {
      const contract = props.contract;

      let medicalDevices = null;
      let displayDevice = null;
      if (contract.contractDevicesDetail) {
          let medicalDeviceList = [];
          const contractDevicesDetail = JSON.parse(contract.contractDevicesDetail);
          contractDevicesDetail.medicalDevice.sort(function(a, b) {
              if (DeviceType.enumValueOf(a.deviceType).ordinal < DeviceType.enumValueOf(b.deviceType).ordinal) {
                  return -1;
              }
              if (DeviceType.enumValueOf(a.deviceType).ordinal > DeviceType.enumValueOf(b.deviceType).ordinal) {
                  return 1;
              }
              return 0;
          });
          contractDevicesDetail.medicalDevice.map(device => {
              const deviceType = DeviceType.enumValueOf(device.deviceType);
              let medicalDevice = deviceType.title;

              if (device.side) {
                  let sideTypeList = [];
                  device.side.sort();
                  device.side.map(sideType => {
                      sideTypeList.push(SideType.enumValueOf(sideType).title);
                  });
                  medicalDevice += ` (${sideTypeList.join(', ')})`;
              }
              medicalDeviceList.push(medicalDevice);
          });

          medicalDevices = medicalDeviceList.join(', ');

          if (contractDevicesDetail.androidDevice) {
              displayDevice = contractDevicesDetail.androidDevice.deviceName;
          }
      }

      const contractId                =  contract.contractId;
      const contractSerialNo          =  contract.contractSerialNo === null ? "" :  contract.contractSerialNo;
      const createdDate = moment(contract.createdTime).format('YYYY-MM-DD');

      const currencyType = CurrencyType.enumValueOf(contract.currencyName);
      const currency = contract.currencyString;
      const decimalScale = currencyType.decimalScale;

      this.setState({
          contractId,
          medicalDevices,
          displayDevice,
          createdDate,
          contractStatus: ContractStatus.enumValueOf(contract.contractStatus),
          contractSerialNo,
          currencyType,
          currency,
          decimalScale,
          patientSubscription: contract.patientSubscription ? contract.patientSubscription : {patientId:props.patientId},
          payments: contract.payments
      });
  }

  getArrowIcon = (expand) => {
    return expand ? 'arrow-up' : 'arrow-down';
  };

  expandButtonClickHandler = () => {
    let expand = this.state.expand;

    this.setState({
      expand: !expand,
      arrowButton: this.getArrowIcon(!expand),
    });
  };

  getAmountFormat = (title, amountValue, renderText) => {
    return (
        <ContractDetailItem>
          <ContractDetailTitle>{title}</ContractDetailTitle>
          {
            this.state.currency ? (
                <NumberFormat
                    displayType="text"
                    thousandSeparator
                    prefix={`${this.state.currency} `}
                    decimalScale={this.state.decimalScale}
                    fixedDecimalScale
                    value={amountValue}
                    renderText={value => renderText(value)}
                />
            ) : null
          }
        </ContractDetailItem>
    );
  };

    getContractDetailBooleanItem = (title, description) => {
        return (
            <ContractDetailItem>
                <ContractDetailTitle>{title}</ContractDetailTitle>
                <div>{description ? "Y" : "N"}</div>
            </ContractDetailItem>
        );
    };

  getContractDetailItem = (title, description) => {
    return (
        <ContractDetailItem>
          <ContractDetailTitle>{title}</ContractDetailTitle>
          <div>{description}</div>
        </ContractDetailItem>
    );
  };

  contractCancelButtonClickHandler = () => {
    this.setState({
      showCancelContractModal: true,
    });
  };

    contractActivateButtonClickHandler = () => {
        this.setState({
            showActivateContractModal: true,
        });
    };

  editProductButtonClickHandler = () => {
    this.setState({
      showEditProductModal: true,
    });
  };



 serialNoChangeHandler = (event) => {
    let contractSerialNo = event.target.value;
    this.setState({contractSerialNo});
  };

  updateSerialNo = () => {
    this.props.showLoading();
    updateSerialNo(this.state.contractId, this.state.contractSerialNo, (err, result) => {
      this.props.hideLoading();
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
          Messenger().post({
              type: 'success',
              message: 'Serial no updated successfully!',
              showCloseButton: true,
          });
      }
    });
  };


  closeCancelContractModal = (contract = null) => {
    this.setState({
      showCancelContractModal: false,
    });

    if (contract) {
      this.setState({
        contractStatus: ContractStatus.enumValueOf(contract.contractStatus),
      });
    }
  };

  closeActivateContractModal = (contract = null) => {
      this.setState({
            showActivateContractModal: false,
      });
      this.props.contractUpdated()
  };

  closeEditProductModal = (event, medicalDevices) => {
    this.setState({
      showEditProductModal: false,
    });
    if (medicalDevices) {
        this.props.contractUpdated()
    }
  };

    changePatientSubscriptionEndDate = (date) => {
        let patientSubscription = this.state.patientSubscription;
        patientSubscription.patientSubscriptionEndTime  = date;

        this.setState({
            patientSubscription
        });
    };

    changePatientSubscriptionStartDate = (date) => {
        let patientSubscription = this.state.patientSubscription;
        patientSubscription.patientSubscriptionStartTime  = date;

        this.setState({
            patientSubscription
        });
    };

    subscriptionStatusChangeHandler = (event) => {
        const status = event.target.value;
        let patientSubscription = this.state.patientSubscription;
        patientSubscription.patientSubscriptionStatus  = status;

        this.setState({
            patientSubscription
        });
    };

    updateSubscription = () => {
        let patientSubscription = this.state.patientSubscription;

        const patientSubscriptionStartTime = moment(patientSubscription.patientSubscriptionStartTime);
        const patientSubscriptionEndTime   = moment(patientSubscription.patientSubscriptionEndTime);
        const patientSubscriptionStatus    = patientSubscription.patientSubscriptionStatus;
        const patientId                    = patientSubscription.patientId;


        const isBefore = patientSubscriptionEndTime.isBefore(patientSubscriptionStartTime, 'day');
        if (isBefore) {
            return alert(`End date can't faster than Start date. Please reset date.`);
        }

        updatePatientSubscription({
                patientSubscriptionId : patientSubscription.patientSubscriptionId,
                patientSubscriptionStartTime : patientSubscriptionStartTime.valueOf(),
                patientSubscriptionEndTime : patientSubscriptionEndTime.valueOf(),
                patientSubscriptionStatus : patientSubscriptionStatus,
                patientId : patientId
            }, (err, result) => {
            if (err) {
                Messenger().post({
                    type: 'error',
                    message: `${err.message} (${err.statusCode})`,
                    showCloseButton: true,
                });
            } else {
                if (result.statusCode === "0" || result.statusCode === 0) {
                    Messenger().post({
                        type: 'success',
                        message: 'Save changes successfully.',
                        showCloseButton: true,
                    });
                } else {
                    Messenger().post({
                        type: 'error',
                        message: result.statusMessage,
                        showCloseButton: true,
                    });
                }
            }
        });
    };

    handleContractUpdated = () => {
        this.props.contractUpdated()
    }

  render() {
    return (
        <Container expand={this.state.expand}>
          <ContractInfo expand={this.state.expand}>
            <Col xs={3}>{this.state.createdDate}</Col>
            <Col xs={8}>
              {this.state.contractStatus ? (
                  <ContractStatusText isActive={this.state.contractStatus === ContractStatus.ACTIVE}>
                    {this.state.contractStatus.statusName}
                  </ContractStatusText>
              ) : null}
              <ContractCancelButton
                 style={{display: (this.state.contractStatus === ContractStatus.ACTIVE ? 'inline-block': 'none')}}
                  onClick={this.contractCancelButtonClickHandler}
              >
                Cancel
              </ContractCancelButton>
                <ContractActivateButton
                    style={{display: (this.state.contractStatus !== ContractStatus.ACTIVE ? 'inline-block': 'none')}}
                    onClick={this.contractActivateButtonClickHandler}
                >
                    Activate
                </ContractActivateButton>
              {this.state.contractStatus === ContractStatus.ACTIVE ? (
              <EditProductButton onClick={this.editProductButtonClickHandler}>Edit Product</EditProductButton>
              ) : null}
            </Col>
            <Col xs={1}>
              <ExpandButton>
                <Icon bundle="ikons" glyph={this.state.arrowButton} onClick={this.expandButtonClickHandler} />
              </ExpandButton>
            </Col>
          </ContractInfo>
          {
            this.state.expand ? (
                <ContractDetail xs={12}>
                  <Title>Subscription Info</Title>
                  {this.getContractDetailItem('Product', this.state.medicalDevices)}
                  {this.getContractDetailItem('Display', this.state.displayDevice)}
                  <ContractDetailItem>
                      <ContractDetailTitle>Serial No</ContractDetailTitle>
                      <div>
                          <FormGroup>
                              <InputGroup>
                                  <FormControl type='text' placeholder='Serial No' width="200px" onChange={this.serialNoChangeHandler} value={this.state.contractSerialNo} />
                                  {
                                      this.state.contractStatus === ContractStatus.ACTIVE &&
                                      <InputGroup.Button>
                                          <Button bsStyle='red'  onClick={this.updateSerialNo}>Save</Button>
                                      </InputGroup.Button>
                                  }
                              </InputGroup>
                          </FormGroup>
                      </div>
                  </ContractDetailItem>
                    <ContractDetailItem style={{borderBottom: "1px solid #d8d8d8"}}>
                        <ContractDetailTitle>Subscription</ContractDetailTitle>
                        <Table style={{width: '440px'}}>
                            <tbody>
                            <tr>
                                <td style={{borderTop: "0px"}}>
                                        <ControlLabel>Status</ControlLabel>
                                        <FormControl
                                            componentClass="select"
                                            placeholder="select"
                                            value={this.state.patientSubscription.patientSubscriptionStatus}
                                            onChange={this.subscriptionStatusChangeHandler}
                                            style={{width: '130px'}}
                                        >
                                            {
                                                SubscriptionStatus.enumValues.map(status=> (
                                                    <option key={status.name} value={status.name}>{status.statusName}</option>
                                                ))
                                            }
                                        </FormControl>
                                </td>
                                <td style={{borderTop: "0px"}}>
                                    <ControlLabel>Start</ControlLabel>
                                    <DatePicker
                                    selected={this.state.patientSubscription.patientSubscriptionStartTime}
                                    onChange={(date) => this.changePatientSubscriptionStartDate(date)}
                                    withPortal
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select" />
                                </td>
                                <td style={{borderTop: "0px"}}>
                                    <ControlLabel>End</ControlLabel>
                                    <DatePicker
                                        selected={this.state.patientSubscription.patientSubscriptionEndTime}
                                        onChange={(date) => this.changePatientSubscriptionEndDate(date)}
                                        withPortal
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"/>
                                </td>
                                <td style={{borderTop: "0px"}}>
                                    <ControlLabel>&nbsp;</ControlLabel>
                                    {
                                        this.state.contractStatus === ContractStatus.ACTIVE &&
                                        <Button bsStyle='red'  onClick={this.updateSubscription}>Save</Button>
                                    }

                                </td>
                            </tr>
                            </tbody>
                        </Table>
                    </ContractDetailItem>
                    <PaymentInfo
                        paymentUpdated={this.handleContractUpdated}
                        contract={this.props.contract}
                        currency={this.state.currency}
                        decimalScale={this.state.decimalScale}
                    />
                    <BalanceInfo
                        contract={this.props.contract}
                        currency={this.state.currency}
                        decimalScale={this.state.decimalScale}
                    />
                    <ArInfo
                        contract={this.props.contract}
                        currency={this.state.currency}
                        decimalScale={this.state.decimalScale}
                    />
                    {
                        this.props.contract.contractPgBillingKey &&
                        <Charge
                            charged={this.handleContractUpdated}
                            contract={this.props.contract}
                            currency={this.state.currency}
                            decimalScale={this.state.decimalScale}
                        />
                    }
                    {
                        this.state.payments.length > 0 ? (
                            <PaymentHistory
                                paymentUpdated={this.handleContractUpdated}
                                contract={this.props.contract}
                                paymentList={this.state.payments}
                                currency={this.state.currency}
                                currencyType={this.state.currencyType}
                            />
                        ) : null
                    }
                </ContractDetail>
            ) : null
          }

          <CancelContractModal
              contractId={this.props.contract.contractId}
              showModal={this.state.showCancelContractModal}
              closeModal={this.closeCancelContractModal}
          />
            <ActivateContractModal
                contractId={this.props.contract.contractId}
                showModal={this.state.showActivateContractModal}
                closeModal={this.closeActivateContractModal}
            />

         {this.state.contractStatus === ContractStatus.ACTIVE ? (
          <EditProductModal
              contract={this.props.contract}
              showModal={this.state.showEditProductModal}
              closeModal={this.closeEditProductModal}
          />
          ) : null}
        </Container>
    );
  }
}

Contract.propTypes = {
    contractUpdated: PropTypes.func.isRequired,
    contract: PropTypes.shape({
        contractId: PropTypes.number,
        currencyName: PropTypes.string,
        currencyCode: PropTypes.string,
        currencyString: PropTypes.string,
        contractSalesRepEmail: PropTypes.string,
        contractPatientEmail: PropTypes.string,
        contractPgType: PropTypes.string,
        contractPgBillingKey: PropTypes.string,
        contractDevicesDetail: PropTypes.string,
        contractBillingDate: PropTypes.number,
        nextPaymentDate: PropTypes.string,
        contractStatus: PropTypes.string,
        installmentPeriod: PropTypes.number,
        contractOnetimeAmount: PropTypes.number,
        contractHardwareAmount: PropTypes.number,
        contractPostalCode: PropTypes.string,
        contractTaxRate: PropTypes.number,
        patientSubscription: PropTypes.object,
        payments: PropTypes.array,
        schedule: PropTypes.object,
        createdTime: PropTypes.number,
        updatedTime: PropTypes.number,
    }).isRequired,
};

export default Contract;



// WEBPACK FOOTER //
// ./src/routes/patient/Contract.js